import { createRealtimeEventBus } from '@src/shared/realtime';

/** Topic on the shared application socket, matching TASK_SUMMARY_TOPIC in
 * apps/task_management/services/summary_events.py. */
export const TASK_SUMMARY_TOPIC = 'tasks.summary';

export type TaskSummaryChangedEvent = {
  reason: string;
  taskId?: number;
  changeReason?: string;
};

const taskRealtimeEventBus = createRealtimeEventBus<TaskSummaryChangedEvent>();

export function publishTaskRealtimeEvent(event: TaskSummaryChangedEvent) {
  taskRealtimeEventBus.publish(event);
}

export function subscribeToTaskRealtimeEvents(
  listener: (event: TaskSummaryChangedEvent) => void,
) {
  return taskRealtimeEventBus.subscribe(listener);
}
